module.exports = __webpack_public_path__ + "static/ke-headshot@1x-7ca37bc309b7b4b294951a4cb454517d.png";